import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Container } from "@mui/material";
// components
import { MotionContainer, varBounceIn } from "../components/animate";
import PropTypes from "prop-types";
import Page from "../components/Page";
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    display: "flex",
    minHeight: "100%",
    alignItems: "center",
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
}));

Page404.propTypes = {
    pageTitle: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    disableGoBack: PropTypes.bool,
};

// ----------------------------------------------------------------------

export default function Page404({ pageTitle, title, text, disableGoBack }) {
    const { t } = useTranslation();
    const defaultTitle = t("Page404.defaultTitle");
    const defaultText = t("Page404.defaultText");
    const defaultPageTitle = t("Page404.defaultPageTitle");
    return (
        <RootStyle title={pageTitle ? pageTitle : defaultPageTitle}>
            <Container maxWidth={false}>
                <MotionContainer initial="initial" open>
                    <Box
                        sx={{
                            maxWidth: 480,
                            margin: "auto",
                            textAlign: "center",
                        }}
                    >
                        <motion.div variants={varBounceIn}>
                            <Typography variant="h3" paragraph>
                                {title ? title : defaultTitle}
                            </Typography>
                        </motion.div>
                        <Typography sx={{ color: "text.secondary" }}>
                            {text ? text : defaultText}
                        </Typography>

                        <motion.div variants={varBounceIn}>
                            <Box
                                component="img"
                                src="/static/illustrations/illustration_404.svg"
                                sx={{
                                    height: 260,
                                    mx: "auto",
                                    my: { xs: 5, sm: 10 },
                                }}
                            />
                        </motion.div>
                        {!disableGoBack && (
                            <Button
                                to=""
                                size="large"
                                variant="contained"
                                component={RouterLink}
                            >
                                {t("Page404.goBackButton")}
                            </Button>
                        )}
                    </Box>
                </MotionContainer>
            </Container>
        </RootStyle>
    );
}
